"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductHeroViewAttributes = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const react_1 = require("react");
const react_2 = require("react");
const Radio = (0, app_1.styled)(ui_1.ChoiceInput) `
  display: flex;
  gap: 0;
  width: 100%;

  > label {
    border-radius: 0;
    background: #eef2fd;
    flex: 1;
    text-align: center;
    padding: ${(theme) => theme.spacing.extraSmall};
  }

  > label:not(:first-of-type) {
    border-left: none;
  }

  > [aria-checked] {
    background: ${(theme) => theme.colors.primary};
    * {
      color: white;
    }
  }

  > [aria-disabled] {
    opacity: 0.5;
  }
`;
function getAllPossibleCombinations(data, variants) {
    const combinations = [];
    function helper(index, current) {
        if (index === data.length) {
            combinations.push(current);
            return;
        }
        const attribute = data[index];
        for (const value of attribute.values) {
            const newCurrent = Object.assign(Object.assign({}, current), { [attribute.id]: value.id });
            helper(index + 1, newCurrent);
        }
    }
    helper(0, {});
    return combinations.filter((combination) => variants.some((variant) => Object.entries(combination).every(([key, value]) => {
        var _a;
        return (_a = variant.attributes) === null || _a === void 0 ? void 0 : _a.some((a) => a.attribute.id === key && a.id === value);
    })));
}
function getPossibleFields(combinations, state) {
    const result = {};
    for (const key of Object.keys(state)) {
        const otherKeys = Object.keys(state).filter((k) => k !== key);
        const possibleValues = combinations.filter((c) => otherKeys.every((k) => c[k] === state[k]));
        result[key] = possibleValues.map((v) => v[key]);
    }
    return result;
}
function ProductHeroViewAttributes({ attributes, variants, setSelectedVariantId, }) {
    var _a;
    const mappedAttributes = (0, react_1.useMemo)(() => attributes.map((v) => (Object.assign(Object.assign({}, v), { values: v.values.filter((value) => variants.some((variant) => { var _a; return (_a = variant.attributes) === null || _a === void 0 ? void 0 : _a.some((a) => a.id === value.id); })) }))), [attributes, variants]);
    const [selected, setSelected] = (0, react_1.useState)(Object.fromEntries(mappedAttributes.map((a) => [a.id, a.values[0].id])));
    const variantsWithAttributes = (0, react_1.useMemo)(() => variants.filter((v) => { var _a; return (_a = v.attributes) === null || _a === void 0 ? void 0 : _a.length; }), [variants]);
    const possibleCombinations = (0, react_1.useMemo)(() => getAllPossibleCombinations(mappedAttributes, variantsWithAttributes), [mappedAttributes, variantsWithAttributes]);
    const possibleFields = (0, react_1.useMemo)(() => getPossibleFields(possibleCombinations, selected), [possibleCombinations, selected]);
    (0, react_2.useEffect)(() => {
        const variant = variantsWithAttributes.find((v) => Object.entries(selected).every(([key, value]) => { var _a; return (_a = v.attributes) === null || _a === void 0 ? void 0 : _a.some((a) => a.attribute.id === key && a.id === value); }));
        if (variant) {
            setSelectedVariantId(variant.id);
        }
    }, [selected, setSelectedVariantId, variants, variantsWithAttributes]);
    return ((0, jsx_runtime_1.jsx)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: (_a = mappedAttributes === null || mappedAttributes === void 0 ? void 0 : mappedAttributes.filter((v) => !v.static)) === null || _a === void 0 ? void 0 : _a.map((attribute) => {
            return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)("div", { children: attribute.title }), (0, jsx_runtime_1.jsx)(Radio, Object.assign({ name: "input", standalone: true, defaultValue: selected[attribute.id], onChange: (v) => {
                            setSelected(Object.assign(Object.assign({}, selected), { [attribute.id]: v }));
                            return v;
                        } }, { children: attribute.values.map((v) => {
                            var _a;
                            return ((0, jsx_runtime_1.jsx)(ui_1.ChoiceInput.Option, Object.assign({ value: v.id, disabled: !((_a = possibleFields[attribute.id]) === null || _a === void 0 ? void 0 : _a.includes(v.id)) }, { children: (0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "span" }, { children: v.value })) }), v.value));
                        }) }))] }), attribute.id));
        }) })));
}
exports.ProductHeroViewAttributes = ProductHeroViewAttributes;
